import Model from '/lib/model'

export default \
class HostField extends Model
  @className: 'HostField'
